import { useQuery } from "@tanstack/react-query"
import api2 from "~/api2"
import { queryKeys } from "~/constants/queryKeys"
import { useCampContext } from "~/contexts/CampProvider"

const useSites = (campId?: string) => {
  const { campId: campIdFromContext } = useCampContext()
  const effectiveCampId = campId || campIdFromContext

  const fetchSites = useQuery({
    queryKey: [queryKeys.SITES, effectiveCampId],
    queryFn: () => apiFetchSites(effectiveCampId),
    staleTime: 3000,
    enabled: !!effectiveCampId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })

  return {
    index: fetchSites,
    refetch: fetchSites.refetch,
  }
}

const apiFetchSites = async (campId: string) => {
  try {
    return await api2.Me.sites_for_camp(campId)
  } catch (error) {
    console.error("Error fetching sites:", error)
    throw error
  }
}

export default useSites
